<template>
  <div @click="flipCard()">
    <div v-bind:style="{backgroundColor: colorFront, color: colorTextFront}" v-show="!isToggle" class="animated flipInX flashcard" style="max-width: 450px;height: 350px;margin-left:auto;margin-right:auto;">
      <div class="card-content center">
        <img :src="imgloc" style="height:275px;"/>
        <p v-bind:style="{fontSize: textSizeFront}">{{front}}</p>
      </div>
      <div class="card-footer">{{footerFront}}</div>
    </div>
    <div v-bind:style="{backgroundColor: colorBack, color: colorTextBack}" v-show="isToggle" class="animated flipInX flashcard" style="max-width: 450px;height: 350px;margin-left:auto;margin-right:auto;">
      <div class="card-content center" style="margin-top:30%;">
       <p v-bind:style="{fontSize: textSizeBack, fontWeight: 'bold'}">{{back}}</p>
	<audio ref="audioElm">
		Your browser does not support the &lt;audio&gt; tag.
		<source :src="audioloc"/>
	</audio>
      </div>
      <div class="card-footer">{{footerBack}}</div>
    </div>
  </div>
</template>

<script>
// Inspired by https://github.com/cuduy197/vue-flashcard
export default {
  props: {
    front: {
      type: String,
      default: 'default front',
    },
    back: {
      type: String,
      default: 'default back',
    },
    audioloc: {
      type: String,
      default: 'default audioloc',
    },
    imgloc: {
      type: String,
      default: 'default imgloc',
    },
    textSizeFront: {
      type: String,
      default: '1.5em'
    },
    textSizeBack: {
      type: String,
      default: '3.5em'
    },
    colorTextFront: {
      type: String,
      default: 'black'
    },
    colorTextBack: {
      type: String,
      default: 'white'
    },
    colorFront: {
      type: String,
      default: 'white'
    },
    colorBack: {
      type: String,
      default: '#398439'
    },
    footerFront: {
      type: String,
      default: ''
    },
    footerBack: {
      type: String,
      default: ''
    },
  },
  computed: {
    isToggle () {
      return this.$store.state.cardFlipped // handled by vuex
    },
  },
  mounted: function () {
	this.$watch('audioloc', function() {this.$refs.audioElm.load();});
	}
  ,
  methods: {
    flipCard () {
      this.$store.commit('flipCard') // handled by vuex
      this.$refs.audioElm.pause();
      if(this.$store.getters.currentSide) {
        this.$refs.audioElm.currentTime = 0;
        this.$refs.audioElm.play();
      }
    },
  },
}
</script>

<style scoped>
.center {
  text-align: center;
}
.flashcard {
  cursor: pointer;
  border-radius: 10px;
  margin: 20px;
  padding: 25px;
  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.4);
  text-align: center;
}
.animated {
  animation-duration: 0.75s;
  animation-fill-mode: both;
}
@keyframes flipInX {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -10deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}
.flipInX {
  backface-visibility: visible !important;
  animation-name: flipInX;
}
</style>
